import { SITE_CARE_MODES } from '../../constants/siteCareModes';

export const LOCAL_PHARMACY_COPY = {
  BADGE: 'Pharmacie locale',
  BADGE_DUTY: 'Armoire de garde',
  TAB_STOCK: 'Stock du site',
  TAB_STOCK_DUTY: 'Stock de garde',
  TAB_DISPENSE: 'Délivrances',
  TAB_ALERTS: 'Alertes',
  STAT_ALERTS: 'Alertes actives',
  STAT_UNITS: 'Unités en stock',
  STAT_PRODUCTS: 'Produits disponibles',
  STAT_LOW: 'Stocks bas',
  STAT_OUT: 'Ruptures',
  STAT_PENDING: 'En attente',
  ALERTS_SECTION: 'Alertes automatiques',
  ALERTS_HINT: 'Ruptures, stocks bas, lots périmés et péremptions proches — temps réel sur ce site.',
  ALERTS_HINT_DUTY:
    'Alertes de l’armoire de garde uniquement — distinctes du stock principal de la pharmacie centrale.',
  STOCK_SECTION: 'Inventaire local',
  STOCK_SECTION_DUTY: 'Armoire de garde',
  STOCK_HINT: 'Lots et péremptions — décrément automatique (FEFO) à la délivrance.',
  STOCK_HINT_DUTY:
    'Stock séparé réapprovisionné par la pharmacie centrale — délivrance nurse / major uniquement depuis cette armoire.',
  EMPTY_STOCK: 'Aucun médicament en stock sur ce site.',
  EMPTY_STOCK_DUTY: 'Armoire de garde vide — demandez un réassort à la pharmacie centrale.',
  EMPTY_STOCK_DUTY_HINT:
    'Le pharmacien central peut alimenter l’armoire depuis le menu « Armoire de garde ».',
  LOADING: 'Chargement de la pharmacie locale…',
  LOADING_SITE: 'Chargement du site…',
  INIT_SITE: 'Initialisation du site de travail…',
  NO_SITES:
    'Aucun site de travail n’est affecté à votre profil. Demandez à un administrateur de vous affecter au moins un site.',
  ACCESS_DENIED: 'La pharmacie locale n’est pas active pour votre rôle sur ce site.'
};

export const SITE_CARE_MODE_LABELS = {
  [SITE_CARE_MODES.DOCTOR_ONLY]: 'Médecin seul',
  [SITE_CARE_MODES.DOCTOR_NURSE_NO_PHARMACY]: 'Médecin + infirmière',
  [SITE_CARE_MODES.NURSE_ONLY_NO_PHARMACY]: 'Infirmière seule',
  [SITE_CARE_MODES.WITH_PHARMACY]: 'Avec pharmacien'
};
